"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPropsContextProvider = void 0;
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const memoize_one_1 = tslib_1.__importDefault(require("memoize-one"));
const react_1 = tslib_1.__importStar(require("react"));
// @ts-ignore
const shallowequal_1 = tslib_1.__importDefault(require("shallowequal"));
/**
 * The provider accepts context values as props, not just single value prop.
 * All props are combined into context value using shallow-equal memoization.
 * So instead <Provider value={{propA:1, propB:2, propC:3}}>...
 * you can use
 * <Provider propA={1} propB={2} propC={3}/>
 */
// eslint-disable-next-line @typescript-eslint/ban-types
const createPropsContextProvider = (context) => {
    const Provider = (_a) => {
        var { children } = _a, rest = tslib_1.__rest(_a, ["children"]);
        const getMemoizedValue = (0, react_1.useMemo)(() => (0, memoize_one_1.default)(lodash_1.identity, ([oldValue], [newValue]) => (0, shallowequal_1.default)(oldValue, newValue)), []);
        return (react_1.default.createElement(context.Provider, { value: getMemoizedValue(rest) }, children));
    };
    return Provider;
};
exports.createPropsContextProvider = createPropsContextProvider;
//# sourceMappingURL=createPropsContextProvider.js.map